import { delay, NAVIGATION_SETTLE_MS } from '../domLocator'
import { ClientTool, studentPageRequested } from '../Tool'

interface Input extends Record<string, unknown> {
  appUserId: number
}

const navigateToStudentPlan: ClientTool = {
  name: 'navigate_to_student_plan',
  category: 'navigate',
  execute: async (rawInput, ctx) => {
    const { appUserId } = rawInput as Input
    ctx.navigate(`/students/${appUserId}/plans`)
    await delay(NAVIGATION_SETTLE_MS)
    return studentPageRequested(ctx.getPathname())
  },
  getStepLabel: () => "Navigating to student's plans…"
}

export default navigateToStudentPlan
